import { useState } from 'react';

import Icon from "@/components/units/Icon";
import {ModalPortal} from "@/components/units/Modal/ModalPortal";
import Modal from "@/components/units/Modal/Modal";
import imageLoader from '@/utility/imageLoader';

const DownloadButton = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const domNode = document.getElementById("modal-container");
  
    const closeModal = () => {
        setIsModalVisible(false);
    };
    return (
        <>
            <button className="tw-px-4 tw-py-2 tw-h-10 tw-flex tw-justify-center tw-items-center tw-gap-2 tw-text-[#75FFFF] hover:tw-bg-[#343434] tw-rounded-full tw-border tw-border-solid tw-border-[#75FFFF1A]"
                onClick={()=>setIsModalVisible(true)}>
                <Icon iconName="app-store-icon" wrapperStyle="tw-w-3 tw-h-3"/>
                <div className="tw-w-0 tw-h-3 tw-border-l tw-border-solid tw-border-[#75FFFF]"></div>
                <Icon iconName="apple-icon" wrapperStyle="tw-w-3 tw-h-3"/>
                <span>Download <span>App</span></span>
            </button>
            {domNode && <ModalPortal domNode={domNode}>
                <Modal 
                    isOpen={isModalVisible} 
                    onClose={closeModal} 
                    className={"tw-bg-[#001316] !tw-max-w-[1080px] tw-text-white tw-relative tw-p-6 max-sm:tw-w-[calc(100%-30px)]"}
                    customClose={
                        <Icon iconName='close' wrapperStyle='tw-bg-[#FFFFFF33] tw-p-2.5 tw-rounded-full tw-cursor-pointer tw-text-white' onClick={closeModal}/>
                    }
                >
                    <div className="tw-flex tw-justify-between tw-box-content">
                        <div className='tw-w-[47.5%] tw-text-[56px] tw-ml-4 max-lg:tw-text-[40px] max-md:tw-text-[45px] max-xs:tw-text-[30px] max-md:tw-w-full max-md:tw-flex max-md:tw-flex-col max-md:tw-items-center max-xs:tw-ml-0'>
                            
                            <p>Download 3 in 1</p>
                            <p className='tw-flex tw-gap-2'><img src={imageLoader('logo.svg')} alt="" className='tw-w-[200px] tw-mr-4 max-lg:tw-w-[150px] max-md:tw-w-[100px]'/>app for </p>
                            <img src={imageLoader("ani-text.gif")} alt="" className='tw-h-[90px] tw-mt-3 max-lg:tw-h-[60px] max-md:tw-h-[75px]'/>
                            <div className="tw-flex tw-flex-1 tw-justify-between tw-mt-10 max-md:tw-max-w-[400px] max-xs:tw-w-full max-xs:tw-flex-col max-xs:tw-items-center max-xs:tw-gap-8 max-xs:tw-mt-5">
                                <img src={imageLoader("download-app-qr.webp")} alt="" className='tw-w-[45%] tw-bg-white tw-p-[3%] tw-rounded-[8%] max-xs:tw-w-[70%]'/>
                                <div className='tw-w-[50%] tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3 max-xs:tw-w-[70%]'>
                                    <a href="https://apps.apple.com/in/app/torus-digital/id6523421422" target="_blank">
                                        <img src={imageLoader("apple-store.webp")} alt="" className='tw-cursor-pointer hover:tw-bg-[#75777777] tw-rounded-[100px]'/>
                                    </a>
                                    <a href="https://play.google.com/store/apps/details?id=com.torus.digital&hl=en" target="_blank">
                                        <img src={imageLoader("play-store.webp")} alt="" className='tw-cursor-pointer hover:tw-bg-[#75777777] tw-rounded-[100px]'/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className='tw-absolute tw-right-0 tw-bottom-0 tw-pointer-events-none tw-w-[70%] max-lg:tw-w-[65%] max-md:tw-hidden'>
                            <img src={imageLoader("shadow-phone.webp")} className='tw-w-[100%]'/>
                              <div class="absolute inset-0 before:absolute before:top-[70%] before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-[1100px] before:h-[600px] before:rounded-full before:bg-[radial-gradient(ellipse_at_center,_#75ffff_-68%,_rgba(255,_0,_0,_0)_60%)] before:pointer-events-none"></div>
                        </div>
                    </div>
                </Modal>
            </ModalPortal>}
        </>
    )
}
export default DownloadButton